<ul *ngIf="accountingInfo" class="charge">
  <!-- Billing -->
  <li class="charge__amount">
    <span class="charge__label">Billing Amount</span>
    <span class="charge__value" *ngIf="accountingInfo.chargeTotal >= 0">
      ${{ commonService.formatNumber(accountingInfo.chargeTotal) | number: '1.0' : 'en-US' }}
    </span>
    <span class="charge__value text-danger" *ngIf="accountingInfo.chargeTotal < 0">
      -${{ commonService.formatNumber(accountingInfo.chargeTotal) | number: '1.0' : 'en-US' }}
    </span>
    <span class="charge__sep">|</span>
  </li>

  <!-- Discount -->
  <li class="charge__amount">
    <span class="charge__label">Property Discount</span>
    <span class="charge__value" *ngIf="accountingInfo.discountTotal >= 0">
      ${{ commonService.formatNumber(accountingInfo.discountTotal) | number: '1.0' : 'en-US' }}
    </span>
    <span class="charge__value text-danger" *ngIf="accountingInfo.discountTotal < 0">
      -${{ commonService.formatNumber(accountingInfo.discountTotal) | number: '1.0' : 'en-US' }}
    </span>
    <span class="charge__sep">|</span>
  </li>

  <!-- Invoice -->
  <li class="charge__amount">
    <span class="charge__label">Invoice Amount</span>
    <span class="charge__value" *ngIf="accountingInfo.invoiceAmount >= 0">
      ${{ commonService.formatNumber(accountingInfo.invoiceAmount) | number: '1.0' : 'en-US' }}
    </span>
    <span class="charge__value text-danger" *ngIf="accountingInfo.invoiceAmount < 0">
      -${{ commonService.formatNumber(accountingInfo.invoiceAmount) | number: '1.0' : 'en-US' }}
    </span>

    <span *ngIf="showAdminFields" class="charge__sep">|</span>
  </li>

  <!-- Partnership -->
  <li class="charge__amount" *ngIf="showAdminFields">
    <span class="charge__label">Partnership Expense</span>
    <span class="charge__value" *ngIf="accountingInfo.referralAmount >= 0">
      ${{ commonService.formatNumber(accountingInfo.referralAmount || 0) | number: '1.0' : 'en-US'
      }}
    </span>
    <span class="charge__value text-danger" *ngIf="accountingInfo.referralAmount < 0">
      -${{ commonService.formatNumber(accountingInfo.referralAmount || 0) | number: '1.0' : 'en-US'
      }}
    </span>
    <span class="charge__sep">|</span>
  </li>

  <!-- Client Marketing -->
  <li class="charge__amount" *ngIf="showAdminFields">
    <span class="charge__label">Client Marketing Amount</span>
    <span class="charge__value" *ngIf="accountingInfo.clientMarketingAmount >= 0">
      ${{ commonService.formatNumber(accountingInfo.clientMarketingAmount || 0) | number: '1.0' :
      'en-US' }}
    </span>
    <span class="charge__value text-danger" *ngIf="accountingInfo.clientMarketingAmount < 0">
      -${{ commonService.formatNumber(accountingInfo.clientMarketingAmount || 0) | number: '1.0' :
      'en-US' }}
    </span>
  </li>
</ul>
